import { fmtTime } from "@/lib/api";
import { roleFor, nameColor } from "@/lib/roles";
import { RoleBadge } from "@/components/RoleBadge";
import { UserActionMenu } from "@/components/chat/UserActionMenu";
import { useAuth } from "@/context/AuthContext";

export function ChatMessage({ msg, showActions = true }) {
  const { user, roles } = useAuth();
  if (msg.role === "system") {
    const isBan = msg.kind === "ban";
    return (
      <div data-testid="chat-system-message" className="text-center my-2">
        <span className={`inline-block text-[11px] rounded-full px-3 py-1 border ${isBan ? "text-red-300 bg-red-950/50 border-red-500/40" : "text-cyan-300/90 bg-cyan-950/40 border-cyan-500/30"}`}>{msg.text}</span>
      </div>
    );
  }
  const mine = user && msg.user_id === user.id;
  const role = roleFor(msg, roles);
  const name = <span className="text-xs font-bold" style={{ color: nameColor(msg, roles) }}>{msg.username}</span>;
  return (
    <div data-testid="chat-message" className={`flex flex-col ${mine ? "items-end" : "items-start"} my-1.5`}>
      <div className="flex items-center gap-2 mb-1 flex-wrap">
        {!mine && showActions ? <UserActionMenu targetId={msg.user_id} username={msg.username}>{name}</UserActionMenu> : name}
        {role && <RoleBadge role={role} size="xs" />}
        <span className="text-[10px] text-slate-600 font-mono-cx">{fmtTime(msg.created_at)}</span>
      </div>
      <div className={`max-w-[85%] rounded-2xl px-3.5 py-2 text-sm leading-relaxed break-words ${mine ? "bg-cyan-500/15 border border-cyan-500/30 text-slate-100 rounded-tr-sm" : "bg-slate-900 border border-slate-800 text-slate-200 rounded-tl-sm"}`}>
        {msg.text}
      </div>
    </div>
  );
}
